"use strict";

module.exports = function (ngModule) {
  require("./formlyUtil")(ngModule);
  require("./formlyWarn")(ngModule);
};


/*****************
 ** WEBPACK FOOTER
 ** ./services/index.js
 ** module id = 20
 ** module chunks = 0
 **/